<!-- FAD MASIVO DESKTOP -->
<div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
    <div class="create-account-container">
        <div class="title">
            <p>Método de pagamento</p>
        </div>
        <div class="form" *ngIf="!methodAdded">
            <div class="methods">
            </div>
            <form class="form" [formGroup]="form" *ngIf="method === 1">
                <mat-form-field appearance="outline">
                    <mat-label>Nome</mat-label>
                    <input maxlength="50" appOnlyLetters formControlName="name" required matInput autocomplete="off"
                           type="text">
                    <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
                </mat-form-field>
                <div class="card-number">
                    <ng-container>
                        <mat-label *ngIf=" !tarjetaValidar && (form.controls.creditCard.value.length === 0 || form.controls.creditCard.value.length > 12)">Número do cartão*</mat-label>
                        <mat-label style="color: #f44336;" *ngIf=" tarjetaValidar || (form.controls.creditCard.value.length !== 0 && form.controls.creditCard.value.length <= 12)">Número do cartão*</mat-label>
                        <mat-form-field appearance="outline">
                            <input (click)="clickComponent()" matInput required appOnlyNumbers [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="code.one" type="text"
                                   autocomplete="off" inputmode="tel" minlength="4" maxlength="4" id="one"
                                   (keyup)="moveOnMax(1,'two',null)"/>
                            <mat-error>Obrigatório</mat-error>
                        </mat-form-field>
                        <span>-</span>
                        <mat-form-field appearance="outline">
                            <input (click)="clickComponent()" matInput required appOnlyNumbers [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="code.two" type="text"
                                   autocomplete="off" inputmode="tel" minlength="4" maxlength="4" id="two"
                                   (keyup)="moveOnMax(2,'three','one')"/>
                            <mat-error>Obrigatório</mat-error>
                        </mat-form-field>
                        <span>-</span>
                        <mat-form-field appearance="outline">
                            <input (click)="clickComponent()" matInput required appOnlyNumbers [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="code.three" type="text"
                                   autocomplete="off" inputmode="tel" minlength="4" maxlength="4" id="three"
                                   (keyup)="moveOnMax(3,'four','two')"/>
                            <mat-error>Obrigatório</mat-error>
                        </mat-form-field>
                        <span>-</span>
                        <mat-form-field appearance="outline">
                            <input (click)="clickComponent()" matInput required appOnlyNumbers [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="code.four" type="text"
                                   autocomplete="off" inputmode="tel" minlength="3" maxlength="4" id="four"
                                   (keyup)="moveOnMax(4,null,'three')"/>
                            <mat-error>Obrigatório</mat-error>
                        </mat-form-field>
                    </ng-container>
                </div>
                <div class="additional-info">
                    <mat-form-field class="expiration" appearance="outline">
                        <mat-label>Data de vencimento</mat-label>
                        <input appOnlyDates maxlength="5" formControlName="expiration" placeholder="MM/YY" required
                               matInput
                               autocomplete="off" type="text">
                        <mat-error *ngIf="form.controls.expiration.hasError('required')">Campo obrigatório</mat-error>
                        <mat-error
                                *ngIf="!form.controls.expiration.hasError('required') && form.controls.expiration.hasError('expirationDate')">
                            Data inválida
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="cvv" appearance="outline">
                        <mat-label>CVV</mat-label>
                        <input appOnlyNumbers minlength="3" maxlength="4" formControlName="cvv" required matInput
                               autocomplete="off" type="password">
                        <mat-error>Campo obrigatório</mat-error>
                    </mat-form-field>
                </div>
                <div class="actions">
                    <button id="continuar_metodo_pago" [disabled]="form.invalid" mat-raised-button (click)="saveData()"
                            class="black-button">CONTINUAR
                    </button>
                </div>
            </form>
        </div>

        <div class="method-added" *ngIf="methodAdded">
            <div class="item" *ngIf="methodData?.name">
                <div class="info">
                    <p class="title">Nome</p>
                    <p>{{methodData?.name}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item" *ngIf="methodData?.creditCard">
                <div class="info">
                    <p class="title">Número do cartão</p>
                    <p>•••• - •••• - •••• - •{{methodData?.creditCard.substring(13, 16) }}</p>
                </div>
                <div class="info" [ngSwitch]="cardType">
                    <p class="title" *ngSwitchCase="'amex'"><img *ngSwitchCase="'amex'"
                                                                 src="assets/images/card/amex.jpg" alt=""></p>
                    <p class="title" *ngSwitchCase="'discover'"><img *ngSwitchCase="'discover'"
                                                                     src="assets/images/card/discover.jpg" alt=""></p>
                    <p class="title" *ngSwitchCase="'jcb'"><img *ngSwitchCase="'jcb'" src="assets/images/card/jcb.jpg"
                                                                alt=""></p>
                    <p class="title" *ngSwitchCase="'maestro'"><img *ngSwitchCase="'maestro'"
                                                                    src="assets/images/card/maestro.jpg" alt=""></p>
                    <p class="title" *ngSwitchCase="'mastercard'"><img *ngSwitchCase="'mastercard'"
                                                                       src="assets/images/card/mastercard.jpg" alt="">
                    </p>
                    <p class="title" *ngSwitchCase="'visa'"><img *ngSwitchCase="'visa'"
                                                                 src="assets/images/card/visa.jpg" alt=""></p>
                    <p class="title" *ngSwitchCase="'visaelectron'"><img *ngSwitchCase="'visaelectron'"
                                                                         src="assets/images/card/visaelec.jpg" alt="">
                    </p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item" *ngIf="methodData?.expiration">
                <div class="info">
                    <p class="title">Data de vencimento</p>
                    <p>••{{methodData?.expiration.substring(2, 5)}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item" *ngIf="methodData?.type">
                <div class="info">
                    <p class="title">Método de pagamento</p>
                    <p>{{methodData?.type}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>
        </div>

        <div class="form">
            <div class="actions" *ngIf="methodAdded">
                <button mat-raised-button (click)="refreshEdit()" class="white-button">EDITAR</button>
            </div>
        </div>
        <div class="disabled" *ngIf="!userData"></div>
    </div>

</div>

<!-- FAD MASIVO RESPONSIVO -->
<div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">

    <div class="content-res">
        Insira o método de pagamento
    </div>

    <div class="form" *ngIf="!methodAdded">
        <div class="methods">
        </div>
        <form class="form" [formGroup]="form" *ngIf="method === 1">
            <mat-form-field appearance="outline">
                <mat-label>Nome</mat-label>
                <input maxlength="50" appOnlyLetters formControlName="name" required matInput autocomplete="off"
                       type="text">
                <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
            </mat-form-field>
            <ng-container *ngIf="isIphone">
                <mat-form-field appearance="outline">
                    <mat-label>Número do cartão</mat-label>
                    <input required matInput appOnlyNumbers formControlName="creditCard" type="password"
                           autocomplete="off" inputmode="tel" minlength="15" maxlength="16"/>
                    <mat-error>Campo obrigatório</mat-error>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="!isIphone">
                <mat-form-field appearance="outline">
                    <mat-label>Número do cartão</mat-label>
                    <input required matInput appOnlyNumbers formControlName="creditCard" type="password"
                           autocomplete="off" inputmode="tel" minlength="15" maxlength="16"/>
                </mat-form-field>
            </ng-container>
            <mat-form-field class="expiration" appearance="outline">
                <mat-label>Data de vencimento</mat-label>
                <input appOnlyDates maxlength="5" formControlName="expiration" placeholder="MM/YY" required matInput
                       autocomplete="off" type="text">
                <mat-error *ngIf="form.controls.expiration.hasError('required')">Campo obrigatório</mat-error>
                <mat-error
                        *ngIf="!form.controls.expiration.hasError('required') && form.controls.expiration.hasError('expirationDate')">
                    Data inválida
                </mat-error>
            </mat-form-field>
            <mat-form-field class="cvv" appearance="outline">
                <mat-label>CVV</mat-label>
                <input appOnlyNumbers minlength="3" maxlength="4" formControlName="cvv" required matInput
                       autocomplete="off" type="password">
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <div class="actions">
                <button id="continuar_metodo_pago_movil" [disabled]="form.invalid" mat-raised-button
                        (click)="saveData()" class="black-button">CONTINUAR
                </button>
            </div>
        </form>
    </div>

    <div class="method-added" *ngIf="methodAdded">
        <div class="item" *ngIf="methodData?.name">
            <div class="info">
                <p class="title">Nome</p>
                <p>{{methodData?.name}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item" *ngIf="methodData?.creditCard">
            <div class="info">
                <p class="title">Número do cartão</p>
                <p>•••• - •••• - •••• - •{{methodData?.creditCard.substring(13, 16) }}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item" *ngIf="methodData?.expiration">
            <div class="info">
                <p class="title">Data de vencimento</p>
                <p>••{{methodData?.expiration.substring(2, 5)}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item" *ngIf="methodData?.type">
            <div class="info">
                <p class="title">Método de pagamento</p>
                <p>{{methodData?.type}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>
    </div>

    <div class="form">
        <div class="actions" *ngIf="methodAdded">
            <button mat-raised-button (click)="refreshEdit()" class="blanco-button">EDITAR</button>
        </div>
    </div>

</div>
